import { Linking } from 'react-native';
import { logError } from '@/utils/logHandling';

export const openLink = async (url: string) => {
  try {
    await Linking.openURL(url);
  } catch (error) {
    logError('Failed to open link:', error, { url });
  }
};
